import { AlertTriangle } from "lucide-react";

interface PageErrorFallbackProps {
  error: Error | null;
  resetError?: () => void;
}

export function PageErrorFallback({ error, resetError }: PageErrorFallbackProps) {
  return (
    <div className="flex h-64 items-center justify-center">
      <div className="max-w-md text-center">
        <AlertTriangle className="mx-auto h-10 w-10 text-destructive" />
        <h2 className="mt-4 text-lg font-semibold text-foreground">
          Something went wrong
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          {error?.message || "An unexpected error occurred."}
        </p>
        {resetError && (
          <button
            onClick={resetError}
            className="mt-4 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
}
